// extracted by mini-css-extract-plugin
export var button = "responsive-collapsible-content-module--button--bCkrk";
export var closed = "responsive-collapsible-content-module--closed--ILZEC";
export var content = "responsive-collapsible-content-module--content--kuwZc";
export var opened = "responsive-collapsible-content-module--opened--OD9I-";
export var responsiveCollapsibleContent = "responsive-collapsible-content-module--responsive-collapsible-content--uOcO9";